const _getLastQuestionQA = (questions) => {
  let lastQuestion = {}
  const unansweredAndNotDismissedQuestions = questions.filter((question) => !question.answered)
    .filter((unanswered) => unanswered.status !== 'dismissed')

  if (unansweredAndNotDismissedQuestions.length) {
    unansweredAndNotDismissedQuestions.sort((a, b) => {
      return new Date(b.createdAt) - new Date(a.createdAt)
    })
    lastQuestion = unansweredAndNotDismissedQuestions[0]
  }
  return lastQuestion
}
export default {
  _getLastQuestionQA,
}
